<template>
  <div class="container" @click="openChat()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="icon">
      <path
        fill="#2971ea"
        d="M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
        class=""
      ></path>
    </svg>
    <span class="label">Chat</span>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
    popUpZIndex: {
      type: Number,
      default: null,
    },
    dealerId: {
      type: String,
      default: null,
    },
    dealerName: {
      type: String,
      default: null,
    },
    adId: {
      type: String,
      default: null,
    },
    adUrl: {
      type: String,
      default: null,
    },
    pageUrlOverride: {
      type: String,
      default: null,
    },
    realmId: {
      type: Number,
      default: null,
    },
    linkName: {
      type: String,
      default: 'tchat-onpage-link',
    },
  },
  created() {
    this.loadTheme(this.theme)
  },
  methods: {
    openChat() {
      let parameters = {}

      if (this.popUpZIndex !== null) {
        parameters.popUpZIndex = this.popUpZIndex
      }

      if (this.dealerId !== null) {
        parameters.dealerId = this.dealerId
      }
      if (this.dealerName !== null) {
        parameters.dealerName = this.dealerName
      }
      if (this.adId !== null) {
        parameters.adId = this.adId
      }
      if (this.adUrl !== null) {
        parameters.adUrl = this.adUrl
      }
      if (this.pageUrlOverride !== null) {
        parameters.pageUrlOverride = this.pageUrlOverride
      }
      if (this.realmId !== null) {
        parameters.realmId = this.realmId
      }
      parameters.linkName = this.linkName
      this.$events.triggerEvent('open-chat', parameters)
    },
    loadTheme() {
      this.$theme.setActiveTheme(this.theme)
      this.$styles.setTheme(this.$theme.getActiveTheme())
    },
  },
}
</script>

<style scoped>
.container {
  font-family: 'Open Sans';
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.label {
  color: #2971ea;
  font-size: 12px;
  padding-left: 5px;
}

.icon {
  width: 15px;
  height: 13px;
}
</style>
